
import { Component, Vue } from 'vue-property-decorator'
import {
  addCompany,
  CompanyAddDto, getCompanyCode,
  getMerchantsGroupList, getMerchantsLevelList,
  getMerchantsTagList,
  GroupListDto,
  LevelListDto,
  TagListDto
} from "@/api/customerManage";
import { Getter } from "vuex-class";
import { DictDataDto, getSyDictDataInfo } from "@/api/commonConfig";

@Component({
  name: 'ValetRegistration'
})
export default class ValetRegistration extends Vue {
  @Getter mobile!: string

  labelWidth = '6em';
  formData: CompanyAddDto = {
    companyName: '',
    industryId: '',
    industryName: '',
    postInfo: '',
    dimensionsId: '',
    dimensionsName: '',
    companyType: 2,
    registMobile: '',
    companyCode: '',
    versionCode:''
  }
  showIndustryPicker = false
  showDimensionsPicker = false
  industryList: DictDataDto[] = []
  dimensionsList: DictDataDto[] = []

  created () {
    this.$nextTick(() => {
      this.getIndustryList()
      this.getDimensionsList()
    })
  }

  // 获取行业字典表
  getIndustryList () {
    getSyDictDataInfo({ dictTypeId: 'industry' }).then((res: any) => {
      this.industryList = res.data || []
    })
  }

  // 获取企业规模字典表
  getDimensionsList () {
    getSyDictDataInfo({ dictTypeId: 'enterpriceScale' }).then((res: any) => {
      this.dimensionsList = res.data || []
    })
  }

  // input输入限制（英文、数字）独立编码
  formatterInput (value) {
    return value.replace(/[^a-zA-Z\d]/g, '')// 英文和数字
  }

  //行业选择弹出框
  industryConfirm (value: DictDataDto) {
    this.formData.industryId = value.dataId;
    this.formData.industryName = value.dataName;
    this.showIndustryPicker = false;
  }

  // 企业规模选择弹出框
  dimensionsConfirm (value: DictDataDto) {
    this.formData.dimensionsId = value.dataId;
    this.formData.dimensionsName = value.dataName;
    this.showDimensionsPicker = false;
  }

  // 确定代客注册
  addSure () {
    (this.$refs.creatCompany as any).validate().then(() => {
      let params = {
        companyCode: this.formData.companyCode,
        companyName: this.formData.companyName,
        companyType: this.formData.companyType,
        dimensionsId: this.formData.dimensionsId,
        industryId: this.formData.industryId,
        postInfo: this.formData.postInfo,
        registMobile: this.mobile,
      }
      addCompany(params).then((res) => {
        /* 1)	界面弹出提示：代客注册成功，登录账号为“登录账户名”，默认密码为123456。点击确认关闭弹出提示。 */
        if (res.code === '000000') {
          this.$dialog.alert({
            title: '代客注册成功',
            message: `登录账号为: ${res.data.loginName} \n \n 默认密码为: 123456`
          }).then(() => {
            this.$router.back()
          })
        }
      })
    });
  }

  companyNameBlur () {
    /* 前端调用后端接口获取拼音首字母 */
    getCompanyCode({ companyCode: this.formData.companyName }).then((res) => {
      this.formData.companyCode = res.data || ''
    })
  }
}
